import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Global error boundary — catches React render crashes (e.g. from browser
 * translation extensions mutating the DOM) and shows a recovery UI instead
 * of a blank page.
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-base-200 px-4">
          <div className="card bg-base-100 shadow-lg max-w-md w-full">
            <div className="card-body items-center text-center">
              <h2 className="card-title text-xl">Algo salio mal</h2>
              <p className="text-base-content/70 text-sm">
                Si tienes traduccion automatica activada en tu navegador,
                desactivala para esta pagina e intenta de nuevo.
              </p>
              <div className="card-actions mt-4">
                <button
                  className="btn btn-primary"
                  onClick={() => window.location.reload()}
                >
                  Recargar pagina
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
